// pages/CreateAccountPage.jsx
import React, { useEffect } from "react";
import RequirePlanSelected from "../components/guards/RequirePlanSelected";
import { useUserDoc } from "../hooks/useUserDoc";
import { getFirestore, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { firebaseApp } from "../firebase/firebaseApp";
import SignUp from "../components/authentication/SignUp";
import { GlassPanel } from "../components/ui/GlassPanel";
import HeroBackground from "../components/HeroBackground";

export default function CreateAccountPage() {
  const { user, data } = useUserDoc();
  const db = getFirestore(firebaseApp);

  useEffect(() => {
    if (
      user?.uid &&
      data?.accountStatus === "registered" &&
      data?.onboarding?.step !== "accountCreated"
    ) {
      setDoc(
        doc(db, "lungform_users", user.uid),
        {
          onboarding: {
            step: "accountCreated",
            accountCreatedAt: serverTimestamp(),
          },
        },
        { merge: true }
      );
    }
  }, [user?.uid, data?.accountStatus]);

  return (
    <RequirePlanSelected>
      <div className="w-full lg:w-2/3 h-full flex flex-col justify-between lg:justify-center items-center gap-4 text-greyscale-1">
        <HeroBackground
          poster="/brand/CoverHero.png"
          videoSrc="/brand/HeroVideo.mp4"
        />
        <div className="flex flex-col items-center justify-center z-10 h-fit w-full">
          <img
            src="/logos/BreatheUltra_Main_Logo.png"
            className="w-2/3 h-auto max-w-lg"
            alt="PDX logo"
          />
        </div>
        <div className="flex flex-col gap-2 p-4 w-full overflow-hidden items-center justify-between max-w-lg relative bg-container rounded-t-2xl lg:rounded-2xl">
          {/* Use the email we saved at anonymous sign-in; lock it to avoid mismatch */}
          <SignUp defaultEmail={data?.email || ""} lockEmail />{" "}
        </div>
      </div>
    </RequirePlanSelected>
  );
}
